<template>
  <div id="admin_businesses_delete_form">
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
      :is_in_admin_view="true"
      :is_in_public_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Delete Business Reason"
      id="admin_delete_business_reason_section"
      v-show="progress == 1"
    >
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Delete
      </v-btn>
    </CardedSectionHeader>
    <CardedForm
      ref="admin_delete_business_reason_form_ref"
      id="admin_delete_business_reason_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit_name"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
      submit_btn_text="Remove"
      submit_btn_color="red"
      v-show="progress == 1"
    >
      <v-alert dense text type="error">
        Please provide a <strong>strong reason</strong> why you are deleting
        this business
      </v-alert>
      <TextArea
        v-model="form.reason"
        :validation_rules="form_validations.reason"
        label="Genuine Reason"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextArea>
      <span
        >To be sure, please enter here the name of the business, that you want
        to delete</span
      >
      <TextField
        v-model="form.business_name"
        :validation_rules="form_validations.business_name"
        label="Enter Business Name "
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete Business Concent Form "
      id="admin_delete_business_concet_form"
      v-show="progress == 2"
    >
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Delete
      </v-btn>
    </CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="business_admin_delete_form_ref"
      id="business_admin_delete_form"
      message="<b>Delete was succesfull</b> <br/> Business has been removed successfully"
      :is_loading="is_loading"
      :seed="{ business: [$route.params.id] }"
      @on-delete-success="on_success_delete"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
      v-show="progress == 2"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedTable from "../../../components/CardedTable";
import CardedForm from "../../../components/CardedForm";
import TextArea from "../../../components/TextArea";
import TextField from "../../../components/TextField";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
export default {
  name: "AdminBusinessesDelete",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedTable,
    CardedForm,
    TextField,
    TextArea,
    DeleteConcentForm,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      is_owner: false,
      business_id: 0,
      business: Utils.get_default_business(),
      errors: [],
      message: "",
      form: {
        reason: "",
        business_name: "",
      },
      form_validations: {
        reason: [
          Utils.validate.min_max_length(
            20,
            400,
            "Reason must be atleast 20 characters and less than 400 characters "
          ),
          Utils.validate.max_length(
            400,
            "Your reason should be less than 200 characters"
          ),
        ],
        business_name: [
          Utils.validate.is_required("Business name is required"),
          Utils.validate.min_max_length(
            3,
            50,
            "Business name should be between 3 and 50 characters "
          ),
        ],
      },
      progress: 1,
    };
  },
  methods: {
    on_auto_fill() {
      this.form.reason =
        "This business nolonger in operation, we have proved that this is the case byond a dought";
      this.form.business_name = this.business.name;
      this.errors = [];
      this.message = "";
    },
    init_form() {
      this.reason = "";
      this.form.business_name = "";
      this.errors = [];
      this.message = "";
      this.progress = 1;
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user ? this._user.id : 0,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.init_form();
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading owners my business ", errors);
        }
      );
    },
    submit_name() {
      this.errors = [];
      this.message = "";
      //check that names match
      if (this.form.business_name.trim() !== this.business.name.trim()) {
        this.errors.push(
          "The name you have entered has to match the business name exactly"
        );

        this.$refs.admin_delete_business_reason_form_ref.show_error_dialog();
        return;
      }
      this.progress = 2;
    },
    submit() {
      this.$emit("on-show-loader");
      ServerClient.Businesses.send_delete_message(
        {
          message: this.form.reason,
          business_id: this.business_id,
          user_id: this.business.user.id,
          email: this.business.email,
          to_name: this.business.user.first_name + " " + this.business.user.last_name,
          business_name: this.business.name
        },
        (res) => {
          this.$emit("on-hide-loader");
          //go to lits of business
          this.on_hide_message();
        },
        (errors) => {
          this.on_hide_message();
          this.$emit("on-hide-loader");
          console.log("Errors sending delete business on admin ", errors);
        }
      );
    },
    on_hide_message() {
      this.$router.push("/admin/businesses/list");
    },
    on_success_delete() {
      this.submit();
    },
  },
  computed: {},
  mounted() {
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if is not admin please redirect this user to the login screen

    this.$emit("set-page-attributes", {
      title: "Admin Delete Business",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/admin/businesses",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/businesses/list/view/" + this.business_id,
        },
        {
          text: "Delete",
          disabled: true,
          href: "/admin/businesses/list/view/" + this.business_id + "/delete",
        },
      ],
      navbar_cols: 3,
    });
    this.load_business(this.business_id);

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_businesses_delete_form", options);
  },
};
</script>